import React from 'react';

import { LOCAL_COLORS } from 'styles/constants';
import { FooterDisclaimer } from 'components/global/FooterDisclaimer';
import { FooterProps } from '..';

export const FOOTER_RETAIL_OFFER_CONTENT: FooterProps = {
  backgroundColor: LOCAL_COLORS.surfaceDarkBold,
  disclaimer: <FooterDisclaimer />,
};

export const FOOTER_RETAIL_LP_OFFER_CONTENT: FooterProps = {
  backgroundColor: LOCAL_COLORS.surfaceDarkBold,
  disclaimer: (
    <React.Fragment>
      <div>
        <sup>1</sup>Based on studies of combination treatments. Custom FormulaRx
        has not been directly studied in comparison with OTC treatments.
      </div>
      <div>
        <sup>2</sup>Based on the number one selling acne treatment as of July
        2023, Differin.
      </div>
      <div>
        <sup>3</sup> In a clinical trial of 150 Curology patients over 12 weeks.
      </div>
      <div>
        <sup>4</sup>In a clinical trial of 150 Curology patients over 12 weeks.
        Self-reported.
      </div>
    </React.Fragment>
  ),
};
